import { getGrowthFeatureDefaults } from "./growth-feature-defaults-copy";

import type { AdPerformanceDemoCopy } from "./CcAdPerformanceDemo";

export type GrowthFeatureAdPerformanceCardCopy = {
  title: string;
  description: string;
  badge: string;
  demo: AdPerformanceDemoCopy;
};

export const DEFAULT_GROWTH_FEATURE_AD_PERFORMANCE_COPY: GrowthFeatureAdPerformanceCardCopy =
  getGrowthFeatureDefaults("en").adPerformance as GrowthFeatureAdPerformanceCardCopy;
